import initialState from './initialState';
import {createReducer} from '../../utils';

export default createReducer(initialState);
